
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const UUIDFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
  onChange: (value: string, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {


  const handleChange = (event: any) => {
    const value = event.target.value;

    onChange(value, layoutField);
  }

  const required = checkLayoutFieldRequirement(layoutField);

  const error = () => {
    if(required &&
       (!value || value == "\"\"")){
         return true
       }
    return false
  };


  return (
      <TextField
         fullWidth
         error={error()}
         disabled={layoutField.AccessSetting_sys === 'read'}
         multiline={false}
         rows={1}
         required={required}
         size="small"
         label={`${layoutField.ReferencedField_sys.Label_sys} (max. ${layoutField.ReferencedField_sys.Length_sys})`}
         variant="filled"
         value={value}
         onChange={(event) => handleChange(event)}
         helperText={layoutField.ReferencedField_sys.HelpText_sys}
         inputProps={{
           maxLength: layoutField.ReferencedField_sys.Length_sys,
         }}
      />

    );

};
